var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0751 10.7451L11.9046 9.06516C11.7998 8.98427 11.6691 8.94436 11.5369 8.95289C11.4048 8.96142 11.2803 9.01782 11.1867 9.11152L10.0347 10.2641C9.94886 10.3507 9.83631 10.4059 9.71524 10.4207C9.59416 10.4354 9.47166 10.4089 9.36755 10.3453C8.99661 10.1179 8.37585 9.67716 7.59908 8.89989C6.82231 8.12371 6.38156 7.50244 6.15409 7.13208C6.09047 7.02806 6.06392 6.90557 6.07878 6.78454C6.09364 6.66352 6.14902 6.55108 6.23591 6.46554L7.38798 5.313C7.48182 5.2195 7.53826 5.09495 7.5467 4.96276C7.55514 4.83057 7.51499 4.69985 7.4338 4.59518L5.75425 2.42429C5.37241 1.93174 4.65237 1.85374 4.18325 2.26556C3.56521 2.80774 2.82281 3.61992 2.60679 4.53137C2.21568 6.17317 2.83372 8.23335 5.55024 10.9497C8.26676 13.6655 10.3271 14.284 11.9684 13.8935C12.8799 13.6764 13.6927 12.9335 14.2349 12.316C14.6462 11.847 14.5682 11.127 14.0751 10.7451Z",
    fill: "#0047FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallPhone);
export default __webpack_public_path__ + "static/media/smallPhone.adcf02d0b6b959b431edb0ac8e890bf9.svg";
export { ForwardRef as ReactComponent };